const normalizeFieldConfiguration = (fields) =>
  fields?.map((field) => {
    return { field: field?.field, placeholder: field?.placeholder };
  });

export default normalizeFieldConfiguration;
